export interface IWindow {
  id: number
  type: WindowTypes
  loaded: boolean
  props: {
    [key: string]: any
  }
  lastPositionX?: number
  lastPositionY?: number
}

export enum WindowTypes {
  IMAGE_VIEWER = 1
}
